export const isLoadingOpeningHours = (state) => state.fetchOpeningHours.loading;
export const selectFetchOpeningHours = (state) => state.fetchOpeningHours.openingHours;
